import AppBackgroundColor from '@components/app-background-color/AppBackgroundColor';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import React from 'react';

import JobCard from '../../../components/cards/JobCard';
import useStyles from '../careers.style';

const title = 'Sales Development Representative - Careers at Guest House';
const description = 'We’re currently looking for a highly motivated and collaborative Sales Development Representative to join our sales and marketing team. In this role, you will be responsible for uncovering demand for our innovative staging platform to help real estate agents transform their listings into thoughtfully designed, shoppable homes. This is an incredible opportunity to join a fast-growing, disruptive startup with advancement potential.';
const jobTitle = 'Sales Development Representative';
const location = 'San Diego - Full Time';
const applyLink = 'https://www.linkedin.com/jobs/view/2874989920/';
const responsibilites = [
  'Work closely with our sales and marketing team to identify, refine, and execute outreach campaign strategies',
  'Maintain a consistent volume of engagement activity across outbound calls, email, SMS, and social selling',
  'Have the ability to articulate Guest House’s unique value proposition and map our benefits to agent’s business',
  'Methodically track tactics, messages, and programs to continually optimize and learn from day-to-day interactions, helping the wider Guest House team better understand customer needs'
];
const experience = [
  'Exceptional written and verbal communication skills (in-person, phone, SMS, and email)',
  'Highly organized and results-oriented',
  'Experience working with real estate agents and/or developers a plus',
  '1-2+ years of sales or customer service experience, ideally at a startup, tech, or real estate services company',
  'Bachelor’s degree preferred'
];

function CareersSalesDevelopmentRepresentative() {
  const { classes, theme } = useStyles();


  return (
    <>
      <AppBackgroundColor backgroundColor="#f6f1f0" />
      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle: title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
        margin={[8, 0]}
      >
        <Grid
          item
          md={8}
          style={{ margin: 'auto' }}
        >
          <JobCard
            jobTitle={jobTitle}
            location={location}
            applyLink={applyLink}
            style={{ textAlign: 'left' }}
          >
            <Typography
              component="h2"
              variant="h4Alt"
              className={classes.jobDescriptionHeader}
            >
              The Role
            </Typography>

            <Typography className={classes.jobDescriptionText}>
              We’re currently looking for a highly motivated and collaborative Sales Development Representative to join our sales and marketing team. In this role, you will be responsible for uncovering demand for our innovative staging platform to help real estate agents transform their listings into thoughtfully designed, shoppable homes. This is an incredible opportunity to join a fast-growing, disruptive startup with advancement potential.
            </Typography>

            <Typography
              component="h3"
              variant="h5Alt"
              className={classes.jobDescriptionHeader}
            >
              As a Sales Development Representative at Guest House, you will:
            </Typography>

            {responsibilites.map((responsibility, i) => (
              <Typography
                key={i}
                component="ul"
              >
                <Typography
                  component="li"
                  className={classes.jobDescriptionText}
                >
                  {responsibility}
                </Typography>
              </Typography>
            ))
            }

            <Typography
              className={classes.jobDescriptionText}
              style={{ margin: theme.spacing(2, 0), fontWeight: 'bold', }}
            >
              We’re prioritizing the following experience and capabilities, and are open to conversations with candidates at different levels. If you’re interested in contributing at an early-stage startup and making a difference, let us know!
            </Typography>
            {experience.map((experience, i) => (
              <Typography
                key={i}
                component="ul"
              >
                <Typography
                  component="li"
                  className={classes.jobDescriptionText}
                >
                  {experience}
                </Typography>
              </Typography>
            ))}
          </JobCard>
        </Grid>
      </ContentBlock>
    </>
  );
}

export default CareersSalesDevelopmentRepresentative;
